
export enum ElectionStatusEnum {
    precount = 'precount', 
    primary = 'primary', 
    recheck = 'recheck', 
    declaration = 'declaration', 
    final = 'final'
}
